const MODAL_REGEX = /\/m\/{1}/;

export function isModalUrl(url: string) {
  return MODAL_REGEX.test(url);
}

export function isRootModalUrl(url: string) {
  const match = url.match(MODAL_REGEX);
  return match && match.index === 0;
}
